import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import Sticky from 'react-stickynode';
import ImpersonaPrompt from './impersona-prompt';
import EditorContent from './content/editor-content';
import EditorSidebar from './sidebar/editor-sidebar';
import useEditorStore from './state-hook';
import theme from '../../../../assets/stylesheets/_settings.global.scss';

export default function WireEditor({
  wire,
  currentProfile,
  mediaTypes,
  cta,
  newNav,
  standfirstSummary,
  showIsCommercial,
  showCTA,
}) {
  const set = useEditorStore(state => state.set);
  const id = useEditorStore(React.useCallback(state => _.get(state.wire, 'id'), []));

  React.useEffect(() => {
    set(state => {
      state.wire = wire;
      state.currentProfile = currentProfile;
      state.mediaTypes = mediaTypes;
      state.cta = cta;
    });
  }, [currentProfile, wire, mediaTypes, set]);

  const domId = `wire-featured-contributors-${id}-update-modal`;
  return (
    <ThemeProvider theme={theme}>
      <div id={domId} />
      <ImpersonaPrompt newNav={newNav} />
      <div className="columnar wire-editor">
        <section className="content">
          {!!id && <EditorContent standfirstSummary={standfirstSummary} showCTA={showCTA} />}
        </section>
        <section className="sidebar">
          <Sticky>
            {!!id && <EditorSidebar showIsCommercial={showIsCommercial} />}
          </Sticky>
        </section>
      </div>
    </ThemeProvider>
  );
}

WireEditor.propTypes = {
  wire: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
  currentProfile: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    isEditor: PropTypes.bool.isRequired,
    canScheduleWire: PropTypes.bool.isRequired,
    canSelectMediaTypes: PropTypes.bool.isRequired,
  }).isRequired,
  mediaTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  cta: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    message: PropTypes.string,
    text: PropTypes.string,
    url: PropTypes.string,
  }),
  newNav: PropTypes.bool.isRequired,
  standfirstSummary: PropTypes.bool.isRequired,
  showIsCommercial: PropTypes.bool.isRequired,
  showCTA: PropTypes.bool,
};

WireEditor.defaultProps = {
  cta: {},
  showCTA: false,
};
